export default {
    resultTitle:"Test Results",
    resultDescription:"Find all your test results in one place",
    testResultPage1Title:"Overview",
    testResultPage2Title:"Feedback",
    overallScoreLabel:"Overall Score",
    testPerformanceScoreLabel:"Performance",
    resultDescriptorLabel:"Result Descriptor",
    resultDescriptorUnavailable: "Not available for this score",
    testResultStrengthsLabel:"Strengths",
    testResultWeaknessesLabel:"Weaknesses",
    retakeTestActionButtonLabel:"Retake test",
    viewDetailedTestResultsActionButtonLabel:"View detailed results",

    seeResultsActionLabel: "See Results",
    errorTagArticleUsageLabel:"Article Usage",
    errorTagCoherenceLabel: "Coherence",
    errorTagFillerWordsLabel:"Filler Words",
    errorTagInvalidOptionLabel:"Invalid option",
    errorTagOffTopicLabel:"Off Topic",
    errorTagPronunciationLabel:"Pronunciation",
    errorTagTenseConfusionLabel:"Tense Confusion",
    errorTagWordChoiceLabel:"Word Choice",
    errorTagSubjectVerbAgreementLabel:"Subject Verb Agreement",
    testCompletionDateLabel:"Completed on {{date}}",
    shareResultsActionButtonLabel:"Share Results",
    shareResultsDialogTitle:"Share your result",
    shareResultsShareActionLabel:"Share",
    shareResultsDownloadActionLabel:"Download image",
    shareResultsImageError:"The result image couldn't be created. Please try again.",
    shareResultsText:"I scored {{score}} on {{test}} with LinguaScore",
    shareResultCardFooter:"Practice test result · linguascores.com",
    shareResultCardBadge:"PRACTICE RESULT",
    shareResultQuestionsLabel:"Questions answered",
    shareResultTimeLabel:"Time spent",
    shareResultImprovementsLabel:"To improve",
    seeAllResultsActionLabel:"See All Results",
}